<template>
  <div class="FAQ bg-white">
    <search-head></search-head>
    <div class="w">
      <div class="back-btn">
        <span class="back pointer" @click="getBack">{{ $t('Home.helpCenter.FAQ.Back') }}</span><span>></span><span class="current-lable">{{ $t('Home.helpCenter.FAQ.FAQ') }}</span>
      </div>
      <div class="faq-main f">
        <div class="faq-menu">
          <h1>{{ $t('Home.helpCenter.FAQ.FrequentlyAskedQuestion') }}</h1>
          <el-menu class="el-menu-vertical-demo" :default-openeds="defaultOpeneds">
            <el-menu-item v-for="(item,index) in categoryList" :key="index"  :index="item.classificationId.toString()" >
                <template slot="title">
                  <span :class="{'active':item.classificationId===essayForm.classificationId}" class="ellipsis el-menu-item-title" @click="selectCategory(item)">{{item.name}}</span>
                </template>
              </el-menu-item>
          </el-menu>
        </div>
        <div class="faq-content">
          <h1>{{category_name}}</h1>
          <div class="essay-box" v-for="(item,index) in essayList" :key="index">
            <h2>{{item.title}}</h2>
            <p v-html="item.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchHead from './components/SearchHead'
import API from '@/api'
import _ from 'lodash'
export default {
  components: { SearchHead },
  data() {
    return {
      listForm: {
        pageNumber: 1,
        pageSize: 10000,
        labelName: 'faq'
      },
      essayForm: {
        pageNumber: 1,
        pageSize: 100000,
        labelName: 'faq'
      },
      category_name: '',
      categoryList: [],
      essayList: [],
      defaultOpeneds: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      index: 0 // 当前选中的下标
    }
  },
  created() {
    this.getEssayCategory()
    if (this.$route.query['_index']) this.index = this.$route.query['_index']
  },
  methods: {
    getEssayCategory() {
      API.getEssayCategory(this.listForm).then(res => {
        this.categoryList = res.data.list.filter(item => { return item.labelName === 'FAQ' })
        let categoryList = _.cloneDeep(this.categoryList)
        let data = categoryList.filter(item => { return item.fullName === this.$route.params.name })
        if (data.length > 0) {
          this.essayForm.classificationId = data[this.index].classificationId
          this.category_name = data[this.index].fullName
        }
        this.getEssayList()
      })
    },
    selectCategory(e) {
      this.essayForm.classificationId = e.classificationId
      this.category_name = e.name
      this.getEssayList()
    },
    getEssayList() {
      API.getEssayList(this.essayForm).then(res => {
        this.essayList = res.data.list
      })
    },
    getBack() {
      this.$router.push('/help-center')
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../css/menus.scss';
.back-btn {
  padding: 70px 0 50px;
  span {
    font-size: 16px;
    font-weight: 400;
    display: inline-block;
  }
  .back {
    color: #121e26;
    margin-right: 12px;
  }
  .current-lable {
    color: #a4a5a9;
    margin-left: 12px;
  }
  .underline {
    width: 60px;
    height: 4px;
    background: #99c41c;
  }
}
.tutorial-list{
  padding-bottom: 60px;
}
.tutorial{
  padding: 27px 20px;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 32px;
  height: 247px;
  box-shadow: 0px 3px 12px 0px rgba(0,0,0,0.16);
  h2{
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    color: #121e26;
    line-height: 30px;
    padding-bottom: 12px;
  }
  p{
    height: 75px;
    margin: 15px 0;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #a4a5a9;
    line-height: 22px;
  }
  a{
    font-size: 16px;
    color: #121e26;
    line-height: 24px;
  }
}
.tutorial:nth-child(3){
  margin-right: 0;
}
.faq-menu {
  width: 30%;
  padding-right: 100px;
  h1 {
    font-size: 20px;
    font-weight: 500;
    color: #121e26;
    padding-bottom: 30px;
  }
}
.faq-content {
  width: 70%;
  h1 {
    font-size: 20px;
    font-weight: 500;
    color: #121e26;
    padding-bottom: 30px;
  }
}
.faq-main {
  padding-bottom: 100px;
}
.essay-box {
  h2 {
    font-size: 16px;
    font-weight: 500;
    color: #121e26;
    line-height: 60px;
  }
}
.active {
  color: #99c41c !important;
}
.el-menu-item-title {
  display: inline-block;
  width: 100%;
  font-size: 18px;
font-weight: 400;
color: #121e26;
}

</style>
<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .quest-main {
    padding-top: 50px;
  }
}
</style>
